import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BrandMark } from '../components/BrandMark';
import { Button } from '../components/ui/Button';
import { AdminThumbnail } from '../components/marco2/AdminThumbnail';
import { MobileThumbnail } from '../components/marco2/MobileThumbnail';
import { ReviewScreenCard } from '../components/marco2/ReviewScreenCard';
import { adminReviewScreens, marco2Deliverables, mobileReviewScreens, notInThisDelivery } from '../data/marco2';
import { withClientReview } from '../utils/clientReview';
const statusBadges = [{
  label: 'PROTÓTIPO',
  text: 'Experiência implementada para validação.'
}, {
  label: 'MARCO 3',
  text: 'Backend e versão Alpha ainda serão implementados.'
}, {
  label: 'FUTURO',
  text: 'Integrações e recursos previstos no roadmap.'
}];
function SectionHeading({
  title,
  subtitle,
  id
}: {
  title: string;
  subtitle: string;
  id: string;
}) {
  return <div className="mb-3 flex flex-col gap-1 border-b border-sand-line pb-2 md:flex-row md:items-end md:justify-between" data-id="element-2881" data-mp="1lef5uda40m5">
      <h2 id={id} className="text-title text-deep" data-id="element-2882" data-mp="2kwwdah1r9sx3">
        {title}
      </h2>
      <p className="text-label text-muted" data-id="element-2883" data-mp="2pvfygf8iz0oe">{subtitle}</p>
    </div>;
}

/** Client review index for Marco 2 — UX/UI e Fundação. Links to existing screens only. */
export function Marco2() {
  const navigate = useNavigate();
  return <div className="min-h-screen w-full bg-sand text-deep" data-id="element-2884" data-mp="2zmalhltli4aw">
      <header className="bg-deep text-sand" data-id="element-2885" data-mp="34i96r0jmn673">
        <div className="mx-auto max-w-[1200px] px-3 pb-6 pt-4 md:px-5" data-id="element-2886" data-mp="34ln7k4cn77cf">
          {/* Interim: the approved gold symbol alone, since the dark-background lockup
              (cream wordmark) is not in the project yet. Swap to that asset when provided. */}
          <BrandMark size={44} data-id="element-2887" data-mp="3ihqynos7yzko" />
          <div className="mt-6 grid gap-4 lg:grid-cols-[1.3fr_1fr] lg:items-end" data-id="element-2888" data-mp="3igzct5ofcg7l">
            <div data-id="element-2889" data-mp="1j7ivtgnu3b5a">
              <h1 className="text-[34px] font-bold leading-[1.08] md:text-[48px]" data-id="element-2890" data-mp="1j828oiymn9cg">BEELYV — Marco 2</h1>
              <p className="mt-1 text-[18px] font-medium text-gold md:text-[20px]" data-id="element-2891" data-mp="1o6vq2mh1bkhw">UX/UI e Fundação</p>
              <p className="mt-3 max-w-[620px] text-[15px] leading-relaxed text-ondark" data-id="element-2892" data-mp="1g665wcwpusm0">
                Este ambiente apresenta os principais fluxos e telas desenvolvidos para o App Mobile e o
                Admin Web do BEELYV, além da fundação definida para a próxima etapa de implementação. Os
                dados exibidos no protótipo são demonstrativos.
              </p>
            </div>
            <ul className="flex flex-col gap-1" aria-label="Legenda de status" data-id="element-2893" data-mp="1z0upfalb0085">
              {statusBadges.map(badge => <li key={badge.label} className="flex items-center gap-2 rounded-card border border-sand/10 bg-deeper px-2 py-[12px]" data-id="element-2894" data-mp="28tjvfpy34lw3">
                  <span className={`shrink-0 rounded-pill border px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide ${badge.label === 'PROTÓTIPO' ? 'border-gold bg-gold text-deep' : badge.label === 'MARCO 3' ? 'border-sand/50 text-sand' : 'border-dashed border-sand/40 text-ondark'}`} data-id="element-2895" data-mp="2iqybvpk0daoe">
                    {badge.label}
                  </span>
                  <span className="text-[13px] leading-snug text-sand" data-id="element-2896" data-mp="2sdr2peumb88w">{badge.text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1200px] px-3 md:px-5" data-id="element-2897" data-mp="2igw7p5xjzpzd">
        <section aria-labelledby="mobile" className="pt-6" data-id="element-2898" data-mp="2iih0or47z0v4">
          <SectionHeading id="mobile" title="App Mobile" subtitle="Principais experiências do usuário" data-id="element-2899" data-mp="24qssv0106yjy" />
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-2900" data-mp="29ou8tc34uhr7">
            {mobileReviewScreens.map(screen => <li key={screen.id} data-id="element-2901" data-mp="1zq53eisfapru">
                <ReviewScreenCard name={screen.name} description={screen.description} route={screen.route} thumbnail={<MobileThumbnail heading={screen.heading ?? screen.name} blocks={screen.preview} data-id="element-2903" data-mp="2y27o2tu11ysx" />} data-id="element-2902" data-mp="1zqelzlb51uni" />
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="admin" className="pt-6" data-id="element-2904" data-mp="2t8we4jtx51ws">
          <SectionHeading id="admin" title="Admin Web" subtitle="Gestão, operação, análise e governança da plataforma" data-id="element-2905" data-mp="2obd0nm51ot5w" />
          <ul className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-2906" data-mp="2faybucsvgvxn">
            {adminReviewScreens.map(screen => <li key={screen.id} data-id="element-2907" data-mp="2ad6dazxq2bkh">
                <ReviewScreenCard name={screen.name} description={screen.description} route={screen.route} thumbnail={<AdminThumbnail title={screen.name} blocks={screen.preview} data-id="element-2909" data-mp="8k8nze35m14a" />} data-id="element-2908" data-mp="2ae7vrph2i0c8" />
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="entregas" className="pt-6" data-id="element-2910" data-mp="b68055i14juy">
          <SectionHeading id="entregas" title="Entregas do Marco 2" subtitle="O que esta etapa consolida" data-id="element-2911" data-mp="b3lq8z7o1s9k" />
          <div className="grid gap-x-4 gap-y-3 md:grid-cols-2 lg:grid-cols-4" data-id="element-2912" data-mp="kv9bujhjkf34">
            {marco2Deliverables.map(item => <div key={item.title} className="border-t-2 border-gold pt-2" data-id="element-2913" data-mp="pum11avvxy8v">
                <h3 className="text-section text-deep" data-id="element-2914" data-mp="3oc82xdjeh3r3">{item.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-2915" data-mp="3oe2lwmb42lsj">{item.description}</p>
              </div>)}
          </div>
        </section>

        <section aria-labelledby="proximo" className="pt-6" data-id="element-2916" data-mp="23yqehul4uim">
          <SectionHeading id="proximo" title="Próxima etapa" subtitle="O que ainda não faz parte desta entrega" data-id="element-2917" data-mp="73l5kwtz4ku2" />
          <div className="grid gap-2 lg:grid-cols-[1.4fr_1fr]" data-id="element-2918" data-mp="1dkq2pcpijnx8">
            <div className="rounded-panel bg-deep p-4 text-sand" data-id="element-2919" data-mp="1dm9heyvitqww">
              <span className="rounded-pill border border-sand/50 px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide" data-id="element-2920" data-mp="1ihgj6158clj6">
                MARCO 3
              </span>
              <h3 className="mt-2 text-title" data-id="element-2921" data-mp="39nusknwz5w55">Marco 3 — Backend + Alpha</h3>
              <p className="mt-2 text-[14px] font-medium text-gold" data-id="element-2922" data-mp="3nmkrm93cu5w5">Ainda não implementado nesta entrega:</p>
              <ul className="mt-1 grid gap-x-3 sm:grid-cols-2" data-id="element-2923" data-mp="3jkprv912o0kh">
                {notInThisDelivery.map(item => <li key={item} className="flex items-center gap-1 border-b border-sand/10 py-1 text-[14px] text-sand" data-id="element-2924" data-mp="2vwq2acfhyg7h">
                    <span className="h-[6px] w-[6px] shrink-0 rounded-pill border border-gold" aria-hidden="true" data-id="element-2925" data-mp="2qy522d08vwj1" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-panel border border-dashed border-deep/30 p-4" data-id="element-2926" data-mp="2zv5le58gj4fm">
              <span className="rounded-pill border border-dashed border-deep/30 px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide text-muted" data-id="element-2927" data-mp="2c5ur96lm48ag">
                FUTURO
              </span>
              <h3 className="mt-2 text-title text-deep" data-id="element-2928" data-mp="1y0kqlspzlshz">Integrações futuras</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-muted" data-id="element-2929" data-mp="22txa5oft793v">
                Apple Health, Google Health Connect, Garmin, Strava e outros serviços externos permanecem
                como integrações futuras e não estão conectados no protótipo atual.
              </p>
            </div>
          </div>
        </section>

        <section aria-labelledby="homologacao" className="py-6" data-id="element-2930" data-mp="2gtewlx5muaa2">
          <div className="flex flex-col gap-3 rounded-panel border border-sand-line bg-white p-4 shadow-card md:flex-row md:items-center md:justify-between md:p-5" data-id="element-2931" data-mp="2lqosnvnj1k6v">
            <div className="max-w-[560px]" data-id="element-2932" data-mp="2btab1spvapcz">
              <h2 id="homologacao" className="text-title text-deep" data-id="element-2933" data-mp="2bs933x45eizh">
                Entrega para homologação
              </h2>
              <p className="mt-1 text-[14px] leading-relaxed text-muted" data-id="element-2934" data-mp="vhepjtmjrh49">
                Esta apresentação integra a entrega do Marco 2 — UX/UI e Fundação do projeto BEELYV.
              </p>
            </div>
            <div className="flex flex-col gap-1 sm:flex-row" data-id="element-2935" data-mp="corf9993hkeu">
              <Button size="lg" onClick={() => navigate(withClientReview('/index'))} data-id="element-2936" data-mp="cn6lvmyio7ik">
                Explorar App Mobile
              </Button>
              <Button size="lg" variant="outline" onClick={() => navigate(withClientReview('/admin'))} data-id="element-2937" data-mp="3ocs04cklv8p">
                Explorar Admin
              </Button>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-sand-line" data-id="element-2938" data-mp="vezdbcxxtko6">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-[4px] px-3 py-3 text-[11.5px] text-muted md:flex-row md:items-center md:justify-between md:px-5" data-id="element-2939" data-mp="vhc32c9xszbs">
          <span data-id="element-2940" data-mp="mm5vb7r3w76m">Desenvolvimento e arquitetura</span>
          <span data-id="element-2941" data-mp="1j4tqxwq2zd9h">
            M AI — Soluções Inteligentes ·{' '}
            <a href="https://mai.dev.br" target="_blank" rel="noreferrer" className="underline decoration-sand-line underline-offset-2 hover:text-deep" data-id="element-2942" data-mp="1j64t5s3vocyh">
              mai.dev.br
            </a>
          </span>
        </div>
      </footer>
    </div>;
}